import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=de156a1e&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=de156a1e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de156a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de156a1e')) {
      api.createRecord('de156a1e', component.options)
    } else {
      api.reload('de156a1e', component.options)
    }
    module.hot.accept("./AppFooter.vue?vue&type=template&id=de156a1e&scoped=true", function () {
      api.rerender('de156a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/AppFooter.vue"
export default component.exports